import React from "react";
import { UISref } from "@uirouter/react";
import styled from "styled-components";

import PortletWrapper from "./PortletWrapper";

const LinkWrapper = styled.div`
    margin-left: 16px;
`;
const WrapperNotFound = styled.div`
    text-align: center;
    margin-top: 2rem;
`;
const Title = styled.div`
    font-size: 5rem;
    font-weight: bold;
    text-transform: uppercase;
    line-height: 5rem;
`;
const Message = styled.div`
    margin-top: 3.625rem;
`;
const Links = styled.div`
    font-size: 1.875rem;
    font-weight: bold;
    text-transform: uppercase;
    line-height: 1.875rem;
    margin-top: 4.375rem;
`;
const House = styled.div`
    margin-top: 4.375rem;
`;
const NotFound = styled.span`
    color: #ff6c0e;
    margin-left: 46px;
`;
const MessageParagraph = styled.p`
    margin: 0;
    font-size: 1.875rem;
    line-height: 3.125rem;
`;
const LinksAnchor = styled.a`
    margin-left: 2.5rem;
    text-decoration: none !important;
`;

const Error = ({ error }) => {
    if (typeof error !== "string") {
        error = "Unknown error.";
    }
    return (
        <PortletWrapper>
            <WrapperNotFound>
                <Title>
                    <span>404</span>
                    <NotFound>Location Not Found</NotFound>
                </Title>
                <House>
                    <img
                        alt="House icon with roof blown off"
                        src="/o/mueller-theme/images/main/house.svg"
                        width="172"
                        height="205"
                    />
                </House>
                <Message>
                    <MessageParagraph>
                        Oops, we weren't able to find the location you were
                        looking for.
                    </MessageParagraph>
                    <MessageParagraph>
                        Perhaps you'd like to check out one of these pages
                        instead:
                    </MessageParagraph>
                </Message>
                <Links>
                    <LinksAnchor href="/home">Home</LinksAnchor>
                    <LinksAnchor href="/sitemap">Sitemap</LinksAnchor>
                    <UISref to="home">
                        <LinksAnchor>Locations</LinksAnchor>
                    </UISref>
                </Links>
            </WrapperNotFound>
        </PortletWrapper>
    );
};

export default Error;



// WEBPACK FOOTER //
// ./components/misc/Error.jsx